// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-grid-col----styles-module---container---3AdC_","md6":"src-components-grid-col----styles-module---md6---3qB-y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/grid-col/styles.module.css
// module id = 625
// module chunks = 168707334958949